import { scrollTo } from './functions';

const $navbar = document.querySelector('#navbar');
const $navbarItems = $navbar.querySelectorAll('.navbar-item');
const $branchen = document.getElementById('anwendungsgebiete');
const $moxicontent = document.getElementById('moxicontent');

// we cant use css scroll-behavior here because of the 150px offset
const scrollToSection = (section) => {
    if (section === null) return;
    scrollTo(section.getBoundingClientRect().top + window.scrollY - 150);
}

// special logic for branchen link - show branchen subnav
Array.from($navbarItems).find(item => item.dataset.metaId === '34').addEventListener('click', e => {
    e.preventDefault();
    e.target.closest('a').classList.toggle('is-open');
    $branchen.classList.toggle('is-hidden');
    $moxicontent.classList.toggle('branchen-active');
    if ($moxicontent.classList.contains('branchen-active') && window.scrollY > 229) {
        scrollTo(0);
    }
});

// special logic for about us sub links - scroll to container
$navbar.querySelectorAll('.navbar-dropdown a').forEach(sublink => {
    sublink.addEventListener('click', e => {
        scrollToSection(document.getElementById(e.target.href.split('#')[1]));
    });
});

// e-globe Navi
let burger = document.querySelector('a.navbar-burger.burger');
let navbar = document.querySelector('div.navbar-menu');
let logo = document.querySelector('nav .navbar-brand>a.logo');
let brand = document.querySelector('nav.navbar .navbar-brand');
let navContainer = document.querySelector('nav.navbar>div.inner-container');

// burger click event
burger.addEventListener('click', function () {
    brand.classList.toggle('is-active');
    logo.classList.toggle('is-hidden');
    navContainer.classList.toggle('is-active');
    burger.classList.toggle('is-active');
    navbar.classList.toggle('is-active');
});

if ($branchen.classList.contains('is-active')) {
    $branchen.classList.remove('is-hidden');
}

// scroll to hash
if (location.hash.length > 0) {
    scrollToSection(document.getElementById(location.hash.substr(1)));
}
